var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.1786,
    cy: 20,
    r: 19.1786,
    fill: "#2F3749"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9618 33.3358C29.4751 36.9387 24.5884 39.1786 19.1786 39.1786C13.7688 39.1786 8.88221 36.9387 5.39551 33.3358C8.33279 31.3938 13.4089 30.1106 19.1787 30.1106C24.9484 30.1106 30.0245 31.3938 32.9618 33.3358ZM28.8786 17.3602C28.8786 23.6426 24.6365 28.7356 19.4035 28.7356C14.1706 28.7356 9.9284 23.6426 9.9284 17.3602C9.9284 11.0777 14.1706 5.9848 19.4035 5.9848C24.6365 5.9848 28.8786 11.0777 28.8786 17.3602Z",
    fill: "#D1D6DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.3572,
    height: 38.3572,
    fill: "white",
    transform: "translate(0 0.821411)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.204027ab199af70d45ba127f2f06e89a.svg";
export { ForwardRef as ReactComponent };